import { css } from '@emotion/css';

export const infoIcon = css`
  margin-left: 4px;
`;
